export default __webpack_public_path__ + "static/media/services.5856c99b.webp";